import { Cookies } from 'react-cookie';

import clearCookie from './clearCookie';

const clearCookies = (cookies: Cookies, toErase: string[], options = {}) => {
  toErase.forEach(key => clearCookie(cookies, key, options));
};

export default clearCookies;
